import { render, staticRenderFns } from "./FacebookLogin.vue?vue&type=template&id=779b5ac3"
import script from "./FacebookLogin.vue?vue&type=script&lang=ts"
export * from "./FacebookLogin.vue?vue&type=script&lang=ts"
import style0 from "./FacebookLogin.vue?vue&type=style&index=0&id=779b5ac3&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779b5ac3')) {
      api.createRecord('779b5ac3', component.options)
    } else {
      api.reload('779b5ac3', component.options)
    }
    module.hot.accept("./FacebookLogin.vue?vue&type=template&id=779b5ac3", function () {
      api.rerender('779b5ac3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FacebookLogin.vue"
export default component.exports